import { LoginForm } from '@components/form/LoginForm';

export const LoginPage = () => {
  return (
    <div className='container flex h-[100vh] flex-col justify-center'>
      <div className='flex h-fit w-full flex-col items-center space-y-10 pb-[15vh]'>
        <h3 className='text-2xl font-bold text-[#333333]'>
          장례식장/파트너 로그인
        </h3>
        <div className='flex h-fit w-full min-w-[380px] max-w-[560px] flex-col items-center justify-center px-8 py-4'>
          <LoginForm className='w-full max-w-[80vw]' />
        </div>
      </div>
    </div>
  );
};
